module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/truora-big-23e73f3102e14857f4096552ac8f103b.svg";